/**
 * `decodeURIComponent` que nunca lança.
 *
 * Sequência percent inválida (`%E3%82`, `%C3%28`) faz o nativo lançar `URIError`. Em
 * `generateMetadata` / `generateStaticParams` isso vira **HTTP 500 cru** — não há error
 * boundary em `(frontend)`, só em `(payload)`.
 *
 * O `src/proxy.ts` exclui do matcher os caminhos de infraestrutura (`sitemap`, `robots.txt`,
 * `indexnow-key.txt`, `favicon.*`, `apple-touch-icon.png`), e lixo com percent-encoding inválido
 * respondia 500 para o crawler. Ver `docs/_arquivo-portalcripto/BUGS_PRODUCAO_CORRECAO_2026_08_04.md` §3.
 *
 * Devolver o valor CRU é o comportamento certo: ele não casa documento nenhum, o chamador
 * cai em `notFound()` e a resposta vira 404 — que é o que aquela URL sempre deveria ter dado.
 *
 * NÃO corrigir isso mexendo no matcher do proxy: fazer `/sitemap.xml` passar pelo proxy o
 * sujeitaria a redirects e rewrites de taxonomia — regressão bem pior que o bug.
 */
export function safeDecodeURIComponent(value: string): string {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}
